import { type ReactNode } from 'react';
import { TriangleAlert } from 'lucide-react';

const PANEL_TITLE = 'text-sm font-semibold text-text-primary';
const SECTION_TITLE = 'text-xs font-semibold text-text-primary';
const ITEM = 'text-xs leading-relaxed text-text-secondary';

function PaperBox({ playerNumber }: { playerNumber: number }): ReactNode {
  return (
    <div className="rounded-md border border-white/[0.08] bg-white/[0.04] px-sm py-xs font-mono text-xs text-text-primary">
      Jugador #{playerNumber} The 3333 Games
    </div>
  );
}

function Section({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}): ReactNode {
  return (
    <div className="space-y-sm">
      <p className={SECTION_TITLE}>{title}</p>
      {children}
    </div>
  );
}

function VerticalLine(): ReactNode {
  return (
    <p className={ITEM}>
      &bull;{' '}
      <span className="font-bold uppercase text-brand-red">En vertical</span>{' '}
      (no horizontal)
    </p>
  );
}

function PhotoSection(): ReactNode {
  return (
    <Section title="3. Foto con móvil">
      <div className="space-y-1.5">
        <p className={ITEM}>&bull; Selfie con buena luz frontal</p>
        <VerticalLine />
        <p className={ITEM}>&bull; Cara visible + papel le&iacute;ble</p>
      </div>
    </Section>
  );
}

function AttitudeSection(): ReactNode {
  return (
    <Section title="1. Actitud">
      <p className={ITEM}>
        &bull; Prohibido poner t&iacute;pica cara postiza de foto, queremos tu
        cara de jugador so&ntilde;ador y logrador.
      </p>
    </Section>
  );
}

function PaperSection({ playerNumber }: { playerNumber: number }): ReactNode {
  return (
    <Section title="2. Hoja de papel (escribir esto exacto)">
      <PaperBox playerNumber={playerNumber} />
    </Section>
  );
}

function ExpulsionNotice(): ReactNode {
  return (
    <div className="flex items-start gap-sm rounded-md border border-brand-red/40 bg-brand-red/10 px-sm py-xs">
      <TriangleAlert size={14} className="mt-[2px] shrink-0 text-brand-red" />
      <p className="text-xs leading-relaxed text-brand-red">
        Incumplir cualquiera de estos requisitos es motivo de expulsi&oacute;n
        inmediata.
      </p>
    </div>
  );
}

export function PhotoInstructions({
  playerNumber,
}: {
  playerNumber: number;
}): ReactNode {
  return (
    <div className="space-y-lg">
      <p className={PANEL_TITLE}>Instrucciones de la foto</p>
      <AttitudeSection />
      <PaperSection playerNumber={playerNumber} />
      <PhotoSection />
      <ExpulsionNotice />
    </div>
  );
}
